import {call, put, takeLatest} from 'redux-saga/effects';
import {push} from 'connected-react-router';
import routes from '../../config/routes';

// Import Notifications and Store Service
import {setNotificationSuccess, setNotificationError} from '../Notifications/actions';
import StoreService from '../../utils/StoreService'

// Import Service
import {
    searchUsersByName,
    assignUserTaskService,
    getTasks,
    completingTask,
    entityApproving,
    getTask,
    taskGroup,
    assignRequestTaskService,
    deleteTaskService,
    getAllApplicantionsService,
    createPriceService,
    getJobCommentService
} from './services';

// Import Constants
import {
    SEARCH_USERS,
    SEARCH_USERS_SUCCESS,
    SEARCH_USERS_ERROR,
    ASSIGN_TASK,
    ASSIGN_TASK_ERROR,
    ASSIGN_TASK_SUCCESS,
    GET_TASKS_SUCCESS,
    GET_TASKS_ERROR,
    GET_TASKS,
    COMPLETE_TASK_SUCCESS,
    COMPLETE_TASK_ERROR,
    COMPLETE_TASK,
    APPROVE_ENTITY_SUCCESS,
    APPROVE_ENTITY_ERROR,
    APPROVE_ENTITY,
    GET_TASK,
    GET_TASK_ERROR,
    GET_TASK_SUCCESS,
    TASK_GROUP_ERROR,
    TASK_GROUP_SUCCESS,
    TASK_GROUP,
    DELETE_TASK_SUCCESS,
    DELETE_TASK_ERROR,
    DELETE_TASK,
    GET_APPLICANTS_SUCCESS,
    GET_APPLICANTS,
    GET_APPLICANTS_ERROR,
    APPLICANTS_PER_PAGE,
    CREATE_PRICE,
    CREATE_PRICE_SUCCESS,
    CREATE_PRICE_ERROR,
    JOB_COMMENT,
    JOB_COMMENT_SUCCESS,
    JOB_COMMENT_ERROR
} from './constants';

// Import Messages
import intl from '../../intl';
import generalMessages from '../generalMessages';
import gtm from '../../config/gtm';
import TagManager from 'react-gtm-module';
import { getApplicationsAction, getTasksAction, sidebarCreatePriceAction, sidbearAction } from './actions';
import axios, { AxiosResponse } from 'axios';
import roles from '../../config/roles';

// Assign Hr User task
function* assignTaskFlow(action: any) {

    const {data, redirect} = action;
    const {sidebar} = data;
    const close: boolean = false;

    try {
      const response: AxiosResponse = yield call(!sidebar ? assignUserTaskService : assignRequestTaskService, data);
      yield put({type: ASSIGN_TASK_SUCCESS, response});

      if(redirect) {
        yield put(push(`${routes.DashboardPage}/tasks`));
      } else {
        StoreService.dispatch(sidbearAction(close));
      }

      StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.TasksNotif)));

    } catch (error) {
      yield put({type: ASSIGN_TASK_ERROR, error})
      StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.FieldMustBeFilled)));
    }
}

// Search Users
function* searchUsers(action: any) {
    const {role, name} = action;

    try {
      const response: AxiosResponse  = yield call(searchUsersByName, role, name);
      yield put({type: SEARCH_USERS_SUCCESS, response});
    } catch (error) {
      yield put({type: SEARCH_USERS_ERROR, error})
    }
}

function* getAllTasks(action: any) {

  const {page, kind, filter, role} = action;

  try {
    if(role === roles.ADMIN) {
      const data = {
        type: kind,
        entity_model: filter === 'no' ? '' : filter,
        page: page
      }
      const response: AxiosResponse  = yield call(getTasks, data);
      yield put({type: GET_TASKS_SUCCESS, response});
    } else {
      const data = {
        type: kind,
        important: filter ? 'yes' : '',
        page: page
      }
      const response: AxiosResponse  = yield call(getTasks, data);
      yield put({type: GET_TASKS_SUCCESS, response});
    }
  } catch(error) {
      yield put({type: GET_TASKS_ERROR, error})
  }
}

// Assign Hr User to Job
function* completeTask(action: any) {

  const {id, data} = action;

  try {
    const response: AxiosResponse  = yield call(completingTask, data, id);
    yield put({type: COMPLETE_TASK_SUCCESS, response});
    yield put(push(`${routes.DashboardPage}/tasks`));
    StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.FinishTaskNotif)));
  } catch (error) {
    yield put({type: COMPLETE_TASK_ERROR})
    StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
  }
}

function* approveEntityFlow(action: any) {

  const {id, data, model} = action;

  try {
    const response: AxiosResponse  = yield call(entityApproving, id, data, model);
    yield put({type: APPROVE_ENTITY_SUCCESS, response});
    yield put(push(`${routes.DashboardPage}/tasks/approve`));
    switch(model) {
      case 'news' :
        StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.NewsApproveNotif)));
      break;
      case 'job' :
        const tagManagerAdArgs = {
          dataLayer: {
              'adId' : data.unique_id,
              'field': data.field_of_work,
              'positionLevel': data.position_level,
              'seniorityLevel': data.seniority,
              'event': gtm.events.adCreated,
          },
        }
        TagManager.dataLayer(tagManagerAdArgs)
        StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.JobApproveNotif)));
      break;
      case 'event' :
        const tagManagerEventArgs = {
          dataLayer: {
             'eventCategory': data.field_of_work,
             'event': gtm.events.eventCreated,
          },
        }
        TagManager.dataLayer(tagManagerEventArgs)
        StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.EventApproveNotif)));
      break;
    }

  } catch (error) {
    if(axios.isAxiosError(error) && error.response) {
      const response = error.response;
      const status = response.status ?? null;
      if(status && status === 409) {
        StoreService.dispatch(setNotificationError('Entitet je već odobren.'));
        yield put(push(`${routes.DashboardPage}/tasks/approve`));
      } else {
        StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
      }
    }
    yield put({type: APPROVE_ENTITY_ERROR});
  }
}

function* getSingleTaskForAdmin(action: any) {
  const {id, page} = action;
  try {
    const response: AxiosResponse  = yield call(getTask, id);
    const {data} = response;
    const {entity} = data;
    if(data.type === 'preselection' || data.type === 'selection') {
      StoreService.dispatch(getApplicationsAction(entity.unique_id, page));
    }
    yield put({type: GET_TASK_SUCCESS, response});
  } catch (error) {
    yield put({type: GET_TASK_ERROR});
  }
}

function* taskGroupFlow() {
  try {
    const response: AxiosResponse  = yield call(taskGroup);
    yield put({type: TASK_GROUP_SUCCESS, response});
  } catch (error) {
    yield put({type: TASK_GROUP_ERROR});
  }
}

function* deleteTaskFlow(action: any) {

  const {data} = action;
  const {uniqueId, type} = data;

  try {
    const response: AxiosResponse  = yield call(deleteTaskService, uniqueId);
    yield put({type: DELETE_TASK_SUCCESS, response});
    StoreService.dispatch(getTasksAction(type))
    StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.SuccessDeleteItem)));
  } catch (error) {
    yield put({type: DELETE_TASK_ERROR});
    StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
  }
}

function* getApplicantionsFlow(action: any) {
  const {id, page} = action;
  try {
    const response: AxiosResponse  = yield call(getAllApplicantionsService, id, page, APPLICANTS_PER_PAGE);
    yield put({type: GET_APPLICANTS_SUCCESS, response})
  } catch (error) {
    yield put({type: GET_APPLICANTS_ERROR, error})
  }
}


function* createJobCommentFlow(action: any) {
  const {id} = action;
  try {
    const response: AxiosResponse  = yield call(getJobCommentService, id);
    yield put({type: JOB_COMMENT_SUCCESS, response})
  } catch (error) {
    yield put({type: JOB_COMMENT_ERROR, error})
  }
}



function* createPriceFlow(action: any) {
  const {data} = action;
  const {task_id} = data;

  try {
    const response: AxiosResponse  = yield call(createPriceService, data);
    yield put({type: CREATE_PRICE_SUCCESS, response});
    // yield put(push(`${routes.DashboardPage}/tasks/${typeTask}`));
    yield put({type: GET_TASK, id: task_id});
    StoreService.dispatch(sidebarCreatePriceAction(false));
    StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.SuccessCreatePrice)));

  } catch (error) {
    yield put({type: CREATE_PRICE_ERROR, error})
    StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
  }
}

// Saga
export default function* tasksSaga() {
    yield takeLatest(SEARCH_USERS, searchUsers);
    yield takeLatest(GET_TASKS, getAllTasks);
    yield takeLatest(APPROVE_ENTITY, approveEntityFlow);
    yield takeLatest(COMPLETE_TASK, completeTask);
    yield takeLatest(GET_TASK, getSingleTaskForAdmin);
    yield takeLatest(TASK_GROUP, taskGroupFlow);
    yield takeLatest(ASSIGN_TASK, assignTaskFlow);
    yield takeLatest(DELETE_TASK, deleteTaskFlow);
    yield takeLatest(GET_APPLICANTS, getApplicantionsFlow);
    yield takeLatest(CREATE_PRICE, createPriceFlow);
    yield takeLatest(JOB_COMMENT, createJobCommentFlow);


}
